import { Service } from '@angular/core';
import { State } from '@ngxs/store';
import { CollectionDataServiceBase } from '@portal-core/data/collection/services/collection-data.service.base';
import { CollectionStateBase } from '@portal-core/data/collection/services/collection-state.base';
import { CollectionStateSelectors } from '@portal-core/data/collection/services/collection-state-selectors.decorator';
import { CshIdCallsReport } from '@portal-core/output-analytics/models/output-analytics-csh-id-calls-report.model';

@CollectionStateSelectors({
  stateType: CshIdCallsReportState
})
@State<CshIdCallsReportState>({
  name: CshIdCallsReportState.source,
})
@Service({ autoProvided: false })
export class CshIdCallsReportState extends CollectionStateBase {
  static override source = 'CshIdCallsReports';
  getSource(): string {
    return CshIdCallsReportState.source;
  }
}

@Service()
export class CshIdCallsReportDataService extends CollectionDataServiceBase<CshIdCallsReport> {
  protected readonly stateType = CshIdCallsReportState;
}
